import { render, staticRenderFns } from "./puzzle-checkmark.vue?vue&type=template&id=2867cfa7"
import script from "./puzzle-checkmark.vue?vue&type=script&lang=js"
export * from "./puzzle-checkmark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports